export enum NavPage {
    Payment,
    Confirmation
}
